
function articleFormatDate(date) {
  if( date ) {
    const m = date.isMoment ? date : moment(date);
    return m.local().format('YYYY-MM-DD HH:mm');
  }

  return null;
}

exports.toFormatArticleDate = articleFormatDate;

exports.prepareBeforeEmitArticleChanged = function(src) {
  var data = _.clone(src);
  if( data.publish_date )
    data.publish_date = moment(data.publish_date).toISOString();
  if( data.startDate )
    data.startDate = moment(data.startDate).toISOString();
  if( data.endDate )
    data.endDate = moment(data.endDate).toISOString();

  return data;
};

exports.prepareForEditArticle = function(src) {
  var data = _.clone(src);
  if( data.publish_date )
    data.publish_date = articleFormatDate(data.publish_date);
  if( data.startDate )
    data.startDate = articleFormatDate(data.startDate);
  if( data.endDate )
    data.endDate = articleFormatDate(data.endDate);

  return data;
};



// WEBPACK FOOTER //
// ./client/src/app/account/rgr-utils.js